import { Switch } from 'antd';
import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';

const tableConfig = (props) => (
	{
		columns: [
			{
				title: 'Title', field: 'title', filterAndSearch: false,
			},
			{
				title: 'Description', field: 'description', filterAndSearch: false,
			},
			{
				title: 'Discount', field: 'discount', filterAndSearch: false,
			},
			{
				title: 'Max discount', field: 'max_discount', filterAndSearch: false,
			},
			// {
			// 	// title: 'Force Update Required', field: 'required', filterAndSearch: false,
			// 	// render: rowData => <div><Switch checked={rowData.required || false} /></div >
			// },
			{
				title: 'Percentage (%)', field: 'is_percentage', filterAndSearch: false,
				render: rowData => <div>
					{rowData.is_percentage ? (
						<CheckCircleIcon htmlColor='green' fontSize='24' />
					) : (
						<CancelIcon htmlColor='red' fontSize='24' />
					)}
				</div>
			},
			{
				title: 'Status', field: 'status', filterAndSearch: false,
				render: rowData => <div>
					{console.log(rowData, "::rowData.STatus")}
					{console.log(rowData.status, "::rowData")}
					{rowData.status ? (
						<CheckCircleIcon htmlColor='green' fontSize='24' />
					) : (
						<CancelIcon htmlColor='red' fontSize='24' />
					)}
				</div>
			},
			// {
			// 	title: 'status', field: 'status', filterAndSearch: false, width: "250px",
			// },
		],
	}
)

export default tableConfig;
